import { RevShareCollapsibleCycleWrapper } from './RevShareCollapsibleCycleWrapper/RevShareCollapsibleCycleWrapper';
import { RevShareSectionHelper } from './RevShareSectionHelper/RevShareSectionHelper';
import { RevShareSubtitle } from './RevShareSubtitle/RevShareSubtitle';
export const RevShareComponents = {
  SectionHelper: RevShareSectionHelper,
  Subtitle: RevShareSubtitle,
  CollapsibleCycleWrapper: RevShareCollapsibleCycleWrapper
};
//# sourceMappingURL=index.js.map